const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%200V35.9L39.8%200L12%2012.2L0%200ZM0.4%2040L28.1%2028L40%2040V4.1L0.4%2040Z'%20fill='%238C1E1E'/%3e%3c/svg%3e";
export {
  e as default
};
